module.exports = __webpack_public_path__ + "img/Download success Icon - charcoal.804d97a2.svg";